"use client";

// ============================================================
// CLUBHUB – Huelle der Anwendung (Aufbau wie im Agent)
// ============================================================
// Die Kopfzeile gehoert der ANWENDUNG und laeuft ueber die volle
// Breite. Darunter teilt sich die Flaeche in Leiste und Inhalt. Auf dem
// Telefon fehlt die Leiste; dort traegt die untere Leiste.
// ============================================================
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { BottomNav } from "./mobile-nav";
import { CommandPalette, useBefehlspalette } from "./command-palette";
import { InstallHint } from "@/components/pwa/install-hint";
import type { CurrentContext } from "@/lib/views";

export function AppShell({ ctx, children }: { ctx: CurrentContext; children: React.ReactNode }) {
  const { offen, setOffen } = useBefehlspalette();
  return (
    <div className="bg-bg-secondary flex min-h-dvh flex-col">
      <Topbar club={ctx.club} clubs={ctx.clubs} user={ctx.user} onSuche={() => setOffen(true)} />
      <div className="flex flex-1 items-start">
        <Sidebar user={ctx.user} />
        <main className="min-w-0 flex-1 px-4 pt-6 pb-[calc(5.5rem+env(safe-area-inset-bottom))] lg:px-6 lg:pb-8">
          {children}
        </main>
      </div>
      <BottomNav club={ctx.club} user={ctx.user} />
      <CommandPalette offen={offen} setOffen={setOffen} />
      <InstallHint />
    </div>
  );
}
